/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {Text, View, TouchableOpacity} from 'react-native';

type Props = {
  pageRecent?: number;
  totalPage?: number;
  handleNext?: any;
  handlePrev?: any;
  labelPrev?: string;
  labelNext?: string;
};
export function Pagination({
  pageRecent,
  totalPage,
  handleNext,
  handlePrev,
  labelPrev,
  labelNext,
}: Props) {
  const page = 'Page ' + pageRecent + ' sur ' + totalPage;
  
  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 16,
        marginVertical: 16,
      }}>
      <TouchableOpacity onPress={handlePrev}>
        <Text>{labelPrev} </Text>
      </TouchableOpacity>
      <Text>{page}</Text>
      <TouchableOpacity onPress={handleNext}>
        <Text>{labelNext}</Text>
      </TouchableOpacity>
    </View>
  );
}
